import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Card,
  CardContent
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { cardStyles, accordionSummaryStyles } from '../basic-info/person-basic-information-styles'

interface RoleSectionProps {
  title: string
  isLoading: boolean
  isEmpty: boolean
  loadingMessage?: string
  emptyMessage?: string
  children?: React.ReactNode
}

export const RoleSection: React.FC<RoleSectionProps> = ({
  title,
  isLoading,
  isEmpty,
  loadingMessage = 'Loading roles data...',
  emptyMessage = 'No roles found for this person.',
  children
}) => {
  const startExpanded = isLoading || isEmpty

  const renderBody = (): React.ReactNode => {
    if (isLoading) {
      return (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography>{loadingMessage}</Typography>
        </Box>
      )
    }
    if (isEmpty) {
      return <Typography>{emptyMessage}</Typography>
    }
    return children
  }

  return (
    <Card sx={cardStyles}>
      <Accordion defaultExpanded={startExpanded}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
          <Typography variant="h6">{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CardContent>{renderBody()}</CardContent>
        </AccordionDetails>
      </Accordion>
    </Card>
  )
}
